// extracted by mini-css-extract-plugin
export default {"toggle-switch":"CheckBox_toggle-switch__ARUyV","switch":"CheckBox_switch__Y4ner"};